module.exports = "/images/gates.jpg?d2d06c66751368c7593b9c38a7750228";